const story = [
  {
    year: "1394",
    items: [
      "اولین دموی آزمایشی رایانش ابری به صورت کاملا خودکار در ایران",
      "موفقیت در پروژه پژوهشگاه فناوری و اطلاعات",
    ],
    img: "demo.svg",
    alt: "",
    title: "",
  },
  {
    year: "1395",
    items: ["بهبود ماشین حساب ابری", "خودکار شدن مراحل دریافت سرویس"],
    img: "budget.svg",
    alt: "",
    title: "",
  },
  {
    year: "1396",
    items: [
      "ابداع SLA در سرویس‌های ابری و اضافه کردن سرویس‌های ساعتی",
      "افتتاح دفتر جدید و رشد 25 برابری مشتریان",
    ],
    img: "consulting.svg",
    alt: "",
    title: "",
  },
  {
    year: "1397",
    items: [
      "راه‌اندازی ابر عمومی پارس‌آنلاین",
      "شروع ارائه مشاوره به سازمان‌ها و مجموعه‌های بزرگ برای استفاده از محصولات ابری",
    ],
    img: "budget.svg",
    alt: "",
    title: "",
  },
  {
    year: "1398",
    items: [
      "جذب سرمایه جدید برای دومین بار و اضافه کردن 2 دیتاسنتر جدید",
      "دریافت مجوز رسمی اپراتوری ابری",
    ],
    img: "analytics.svg",
    alt: "",
    title: "",
  },
  {
    year: "1399",
    items: [
      "اضافه شدن سرویس سکوی ابری(PaaS)",
      "اضافه شدن کلان داده ابری BDaaS و گرافیک ابری GPU",
      "رشد 15 برابری تعداد مشتریان علی‌رغم شیوع ویروس کرونا",
    ],
    img: "sazman.svg",
    alt: "",
    title: "",
  },
  {
    year: "1400",
    items: [
      "اضافه شدن سرویس‌های ترکیبی ابر «آبالون»",
      "راه‌اندازی سرویس‌های مدیریت شده (Managed Services)",
      "راه‌اندازی بازارچه ابری",
    ],
    img: "contract.svg",
    alt: "",
    title: "",
  },
  {
    year: "1401",
    items: [
      "ارائه سرویس کوبرنتیز سازمانی",
      "راه‌اندازی دیتاسنترهای جدید در خارج از کشور و ۵ شهر ایران",
    ],
    img: "container.svg",
    alt: "",
    title: "",
  },
  {
    year: "1402",
    items: ["راه‌اندازی سرویس CDN", "راه‌اندازی سرویس گرافیک ابری"],
    img: "CDN.svg",
    alt: "",
    title: "",
  },
  {
    year: "1403",
    items: [
      "ارائه سرویس ابر ایمن برای اولین بار در ایران",
      "ارائه اولین PAM ابری ایران",
      "ارائه کولوکیشن و سرور اختصاصی",
    ],
    img: "Colocation.svg",
    alt: "",
    title: "",
  },
];

const results = [
  {
    img: "security.svg",
    percent: "37%",
    cap: "سطح امنیت بالاتر و ریسک عملیاتی کمتر",
    alt: "",
    title: "",
  },
  {
    img: "cost.svg",
    percent: "39%",
    cap: "کاهش در هزینه‌های IT و صرفه‌جویی در بودجه",
    alt: "",
    title: "",
  },
  {
    img: "cost.svg",
    percent: "51%",
    cap: "سرعت بیشتر در زمان ورود به بازار و توسعه محصولات",
    alt: "",
    title: "",
  },
  {
    img: "pop.svg",
    percent: "14%",
    cap: "پاپ‌سایت در نقاط مختلف جهان",
    alt: "",
    title: "",
  },
  {
    img: "uptime.svg",
    percent: "99.99٪",
    cap: "زمان uptime تضمین شده",
    alt: "",
    title: "",
  },
];

export default { story, results };
